module.exports = __webpack_public_path__ + "static/media/Line.8ca70de0.svg";